

import Vue from 'vue'

require('es6-promise').polyfill();
import App from './App'
import router from '@/router';




Vue.config.productionTip = false

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'


Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
Vue.component('swiper', Swiper);
Vue.component('x-table', XTable);
Vue.component('cell', Cell);
Vue.component('group', Group);
Vue.component('alert', Alert);
Vue.component('confirm', Confirm);
Vue.component('toast', Toast);
Vue.component('inline-loading', InlineLoading);

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js